import React, { useEffect, useRef } from "react";
import styles from "./WaysToStyleModalThumbnails.scss";
import classnamesBind from "classnames/bind";
import { StylingLookProductWithStockPrice } from "../../types/productTypes/stylingLookProduct";
import Image from "../image/Image";
import { getPrimaryImage } from "../../utils/product";

const classnames = classnamesBind.bind(styles);

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  !!window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;

interface WaysToStyleModalThumbnailsProps {
  products: StylingLookProductWithStockPrice[];
  selectedThumbnailIndex: number;
  onThumbnailSelect: (index: number) => void;
  resetScrollTrigger?: number;
}

const WaysToStyleModalThumbnails: React.FC<WaysToStyleModalThumbnailsProps> = ({
  products,
  selectedThumbnailIndex,
  onThumbnailSelect,
  resetScrollTrigger,
}) => {
  const thumbnailCarouselRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (resetScrollTrigger === undefined) {
      return;
    }

    const thumbnailCarousel = thumbnailCarouselRef.current;

    if (!thumbnailCarousel) {
      return;
    }

    if (typeof thumbnailCarousel.scrollTo === "function") {
      thumbnailCarousel.scrollTo({
        left: 0,
        behavior: prefersReducedMotion() ? "auto" : "smooth",
      });
      return;
    }

    thumbnailCarousel.scrollLeft = 0;
  }, [resetScrollTrigger]);

  return (
    <div
      ref={thumbnailCarouselRef}
      className={styles.thumbnailCarousel}
      data-testid="waysToStyleModalThumbnailCarousel"
    >
      {products.map(
        (product: StylingLookProductWithStockPrice, index: number) => {
          const isSelected = index === selectedThumbnailIndex;
          return (
            <button
              className={classnames(styles.thumbnail, {
                [styles.selected]: isSelected,
              })}
              key={`${product.id}-${index}`}
              onClick={() => onThumbnailSelect(index)}
            >
              <Image
                url={getPrimaryImage(product.images)?.url}
                alternateText={product.name}
                type="thumbnail"
                width={56}
                additionalClasses=""
                loadingType="lazy"
                ariaHidden={false}
              />
            </button>
          );
        }
      )}
    </div>
  );
};

export default WaysToStyleModalThumbnails;
